import { render, staticRenderFns } from "./ShootingDetails.vue?vue&type=template&id=628c85e7&scoped=true&"
import script from "./ShootingDetails.vue?vue&type=script&lang=ts&"
export * from "./ShootingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ShootingDetails.vue?vue&type=style&index=0&id=628c85e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c85e7",
  null
  
)

export default component.exports